<script lang="ts">
	import { SalesSlugPageView } from "#lib/web-ui/fergmar-com/sales-listing/index.js";

	let { data } = $props();
</script>

<SalesSlugPageView listing={data.listing} salesTeam={data.salesTeam} />
